import { Route, Switch } from 'react-router-dom';
import { SettingsPage } from '../../ui/features/settings/pages/SettingsPage';
import { settingsPaths } from './paths/settings.paths';

export const SettingsRouter = () => (
    <Switch>
        <Route path={settingsPaths.settings} component={SettingsPage} />
    </Switch>
);
